module.exports = __webpack_public_path__ + "media/images/icons/twotone/down-square-67e289ffde1fe598adb91e37879b2653.svg";